<template>
  <div class="contract-send-plan">
    <div class="change-title">
      <el-button type="primary" icon="el-icon-plus" @click="onAddShip()">{{ $t('crm_contract_send_plan.tjfhjh') }}</el-button>
      <el-button type="primary" :disabled="!tableSelect.length" @click="onPrint()">
        <i class="icon icon-calendar"></i>
        {{ $t('crm_contract_send_plan.da_yin') }}
      </el-button>
    </div>
    <div class="table-bd">
      <custom-table type="checkbox" v-model="tableSelect" tableCode="contractSendPlan" :data="tableList" :slots="['customShipmentNum', 'consigneeOrgType', 'action']">
        <template v-slot:customShipmentNum="scope">
          <div class="cell-link" @click="onDetails(scope.row)">{{ scope.row.customShipmentNum }}</div>
        </template>
        <template slot="consigneeOrgType" slot-scope="scope">
          <el-tooltip placement="bottom" effect="light">
            <div slot="content">
              <div style="padding: 2px 8px">
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_send_plan.shou_huo_ren') }}： {{ scope.row.consigneeName }}</p>
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_send_plan.dian_hua') }}： {{ scope.row.consigneePhone }}</p>
                <p style="font-size: 14px; line-height: 24px">{{ $t('crm_contract_send_plan.di_zhi') }}： {{ scope.row.consigneeAddress }}</p>
              </div>
            </div>
            <el-button type="text">{{ scope.row.consigneeName }}</el-button>
          </el-tooltip>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" v-if="scope.row.shipperOrgId == orgId && scope.row.receivingState == 0" size="mini" @click="onSendPlan(scope.row)">{{ $t('crm_contract_send_plan.fa_huo') }}</el-button>
          <el-button type="text" v-if="scope.row.shipperOrgId == orgId && scope.row.receivingState == 0" size="mini" @click="onEdit(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" v-if="scope.row.shipperOrgId == orgId && scope.row.receivingState == 0" size="mini" @click="onDelete(scope.row)">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 发货 -->
    <factory-send-plan v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = ''" @success="onSuccess"></factory-send-plan>
    <!-- 新增编辑 -->
    <ship-item-dialog v-if="dialogVisible1" @close="dialogVisible1 = false" :model="dialogModel1" @success="getTableList"></ship-item-dialog>
    <!-- 查看发货单 -->
    <ship-itemDetail-dialog v-if="dialogVisible2" @close="dialogVisible2 = false" :model="dialogModel2"></ship-itemDetail-dialog>
    <!-- 打印发货单 -->
    <contract-download v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false"></contract-download>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import shipItemDialog from '@/pages/crm/components/ship_item_dialog.vue';
import contractDownload from '@/pages/crm/components/contractDownload.vue';
import shipItemDetailDialog from '@/pages/crm/components/ship_itemDetail_dialog.vue';
import factorySendPlan from '../../contractHandle/factory_send_plan.vue';

export default {
  components: {
    factorySendPlan,
    shipItemDialog,
    contractDownload,
    shipItemDetailDialog,
  },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      // 新增编辑
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      //  下载合同
      dialogVisible4: false,
      dialogModel4: {},
      formSearch: {
        orderId: '',
        orgType: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },

      tableList: [],
      tableSelect: [],
      totalRows: null,
    };
  },
  computed: {
    orgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  mounted: function () {
    this.formSearch.orderId = this.getJump('contractId');
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    onSuccess() {
      this.getTableList();
      this.$emit('success');
    },
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.shipPlanPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 物流设备弹窗
    showDeviceList(row) {
      this.dialogModel.title = this.$t('crm_contract_send_plan.she_bei_xin_xi');
      this.dialogModel.customShipmentNum = row.customShipmentNum;
      this.dialogVisible = true;
    },
    // 参数获取
    getOrderClass() {
      // 订单类型，1-调拨 2-租赁 3-销售
      let orderClass = '';
      const bizClass = this.detail.orderClass;
      if (['10', '20', '30'].includes(`${bizClass}`)) {
        orderClass = 2;
      } else if (['40', '50'].includes(`${bizClass}`)) {
        orderClass = 3;
      } else if (['90'].includes(`${bizClass}`)) {
        orderClass = 1;
      }
      return orderClass;
    },
    // 发货
    onSendPlan(row) {
      this.dialogModel = {
        title: this.$t('crm_contract_send_plan.fa_huo'),
        detail: this.detail,
        data: row,
        orderClass: this.getOrderClass(),
      };
      this.dialogVisible = true;
    },
    // 添加发货计划
    onAddShip() {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('crm_contract_send_plan.tjfhjh');
      this.dialogModel1.type = 'add';
      // 项目负责人
      this.dialogModel1.data = {
        orderId: this.detail.bizId,
        orderClass: this.getOrderClass(),
      };
    },
    // 编辑
    onEdit(row) {
      this.dialogModel1 = {
        title: this.$t('crm_contract_send_plan.bjfhjh'),
        type: 'edit',
        data: row,
      };
      this.dialogVisible1 = true;
    },
    // 删除
    onDelete(row) {
      const tips = this.$t('crm_contract_send_plan.nqdyscdqxzdfhjhm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.shipPlanDelete}/${row.orderDeliveryId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_delete'),
            type: 'success',
          });
          this.onPageChange({ page: 1 });
        });
      });
    },
    // 查看发货单
    onDetails(row) {
      this.dialogModel2 = {
        title: this.$t('crm_contract_send_plan.cha_kan_fa_huo_dan'),
        type: 'pending',
        data: row,
      };
      this.dialogVisible2 = true;
    },
    // 打印发货单
    onPrint() {
      const orderDeliveryIds = this.tableSelect.map(item => item.orderDeliveryId).join(',');
      this.dialogVisible4 = true;
      this.dialogModel4 = {
        title: this.$t('crm_contract_send_plan.da_yin_fa_huo_dan'),
        data: {
          // 823921301846863879,825090743624642560
          // orderDeliveryId: '823921301846863879,825090743624642560'
          orderDeliveryId: orderDeliveryIds,
        },
      };
    },
  },
};
</script>

<style lang="scss">
.contract-send-plan {
  padding: 24px;
  background: #fff;

  .table-bd {
    margin-top: 16px;
  }
}
</style>
